import { ActivitySource, ActivitySourceValue } from '../../../types/Activity';

export const isConnectedStripeAccount = (source?: ActivitySourceValue) => {
  return (
    source === ActivitySource.bach2 ||
    source === ActivitySource.redeam ||
    source === ActivitySource.peek ||
    source === ActivitySource.fareharbor ||
    source === ActivitySource.singenuity
  );
};
